import React from "react"
import { FormattedMessage, FormattedNumber } from "react-intl"
import Integrations from "../../../integration/Integrations.jsx"
import PaymentExternalDetails from "../../../payment/externaldetails.component.jsx"
import { PAYMENT_STATUS } from "../../../state/helpers/Payment"
import { PaymentTransactionDto } from "../../../state/payment/PaymentTransaction"
import { PayableEntity } from "../../../state/payableentity/PayableEntity"

type OwnProps = {
    paymentTransaction: PaymentTransactionDto,
    payableEntity: PayableEntity,
    paymentInformation?: React.ReactElement,
}

const ShopifyExternalCheckoutPaymentAttemptEvent = (props: OwnProps) => {

    const displayHeadMessage = (paymentStatus: string) => {
        switch (paymentStatus) {
        case PAYMENT_STATUS.PENDING:
            return <FormattedMessage
                id="common.analytics.events.shopify.payment_pending.text"
                defaultMessage="A checkout attempt of {amount} is in progress for {identifier}"
                values={{
                    identifier: <strong>{props.payableEntity.attributes.identifier}</strong>,
                    amount: <strong>
                        <FormattedNumber
                            value={props.paymentTransaction.attributes.amount}
                            style={"currency"}
                            currency={props.paymentTransaction.attributes.currency}
                        />
                    </strong>,
                }}
            />
        case PAYMENT_STATUS.EXPIRED:
            return <FormattedMessage
                id="common.analytics.events.shopify.payment_expired.text"
                defaultMessage="A checkout attempt of {amount} has expired for {identifier}"
                values={{
                    identifier: <strong>{props.payableEntity.attributes.identifier}</strong>,
                    amount: <strong>
                        <FormattedNumber
                            value={props.paymentTransaction.attributes.amount}
                            style={"currency"}
                            currency={props.paymentTransaction.attributes.currency}
                        />
                    </strong>,
                }}
            />
        default:
            return <FormattedMessage
                id="common.analytics.events.shopify.payment_created.text"
                defaultMessage="A checkout attempt of {amount} was created for {identifier}"
                values={{
                    identifier: <strong>{props.payableEntity.attributes.identifier}</strong>,
                    amount: <strong>
                        <FormattedNumber
                            value={props.paymentTransaction.attributes.amount}
                            style={"currency"}
                            currency={props.paymentTransaction.attributes.currency}
                        />
                    </strong>,
                }}
            />
        }
    }

    const displayExternalLinks = () => {
        const paymentTransactionExternalLink = props.paymentTransaction.attributes.payment.attributes.externalLink

        return (
            paymentTransactionExternalLink ?
                <div className={"col-12 border-top pt-2 mt-2"}>
                    <div className={"w-100"}>
                        <p className={"mb-2"}>
                            <FormattedMessage
                                id="invoice.analytics.events.external_checkout_created.integration"
                                defaultMessage="The checkout was created with {integrationName}"
                                values={{
                                    integrationName: Integrations.getIntegrationNameFromKey(
                                        paymentTransactionExternalLink.attributes.integrationKey
                                    )
                                }}
                            />
                        </p>
                    </div>
                    <PaymentExternalDetails value={props.paymentTransaction.attributes.payment} hideCta={true}/>
                </div> : ""
        )
    }

    return (
        <div className={"row "}>

            <div className="col-12">
                <p className={"mb-1 d-flex align-items-center"}>
                    {displayHeadMessage(props.paymentTransaction.attributes.payment.attributes.status)}
                </p>
            </div>
            {
                props.paymentInformation ?? <></>
            }
            {
                displayExternalLinks()
            }

        </div>

    )
}

export default ShopifyExternalCheckoutPaymentAttemptEvent


// WEBPACK FOOTER //
// ./src/quote/analytics/events/shopify-external-checkout-payment-attempt.component.tsx